const ENTSORGUNGS_VARIANTEN = {
  papier:  '54051726688598',
  folie:   '54051727245654',
  verbund: '54051727442262'
};

let isProcessing = false;
let syncRunning = false;
let syncTimer = null;

function storageKey(material, produktVariantId) {
  return `entsorgung_deaktiviert_${material}_${produktVariantId}`;
}

function sollMengeBerechnen(betragProStueck, produktMenge) {
  return Math.round(betragProStueck * produktMenge * 100);
}

// VPE-Variante (Betrag je Verpackungseinheit) bevorzugen – Menge = Produktmenge.
// Ohne passende Variante: 0,01-€-Variante × Cent wie bisher.
function entsorgungZiel(checkbox, betragProStueck, produktMenge) {
  const vpeVariant = checkbox.dataset.vpeVariant;
  if (vpeVariant) return { variantId: vpeVariant, menge: produktMenge };
  return {
    variantId: ENTSORGUNGS_VARIANTEN[checkbox.dataset.material],
    menge: sollMengeBerechnen(betragProStueck, produktMenge)
  };
}

function entsorgungProps(material, produktVariantId) {
  return {
    '_entsorgung_auto': 'true',
    '_entsorgung_material': material,
    '_fuer_variant_id': produktVariantId,
    'Entsorgungsart': material.charAt(0).toUpperCase() + material.slice(1)
  };
}

async function getCart() {
  return (await fetch('/cart.js')).json();
}

async function cartChange(key, quantity) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  });
}

async function cartAdd(variantId, quantity, properties) {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: quantity, properties: properties }] })
  });
}

// Nur den Warenkorb-Bereich neu rendern – KEIN Seiten-Reload
async function refreshCart() {
  const targets = [
    document.getElementById('main-cart-items'),
    document.getElementById('main-cart-footer')
  ].filter(el => el && el.dataset.id);

  if (!targets.length) { window.location.reload(); return; }

  const ids = targets.map(el => el.dataset.id);
  const res = await fetch(`${window.location.pathname}?sections=${ids.join(',')}`);
  const sections = await res.json();

  targets.forEach(el => {
    const html = sections[el.dataset.id];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('.js-contents');
    const target = el.querySelector('.js-contents');
    if (fresh && target) target.innerHTML = fresh.innerHTML;
  });
}

// Mehrere Auslöser kurz hintereinander zu EINEM Sync bündeln
function scheduleSync() {
  clearTimeout(syncTimer);
  syncTimer = setTimeout(async function() {
    if (syncRunning) { scheduleSync(); return; }
    syncRunning = true;
    try {
      await syncUndAutoAdd();
      initCheckboxEvents();
    } finally {
      syncRunning = false;
    }
  }, 200);
}

document.addEventListener('DOMContentLoaded', async function() {
  await syncUndAutoAdd();
  initCheckboxEvents();

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() { scheduleSync(); });
  }
});

async function syncUndAutoAdd() {
  try {
    const cart = await getCart();

    const entsorgungItems = cart.items.filter(i =>
      i.properties && i.properties['_entsorgung_auto'] === 'true'
    );
    const produktItems = cart.items.filter(i =>
      !i.properties || i.properties['_entsorgung_auto'] !== 'true'
    );
    const echteVariantIds = produktItems.map(i => String(i.variant_id));

    let changed = false;

    // 1) Verwaiste Entsorgungskosten entfernen
    for (const item of entsorgungItems) {
      const linkedId = item.properties['_fuer_variant_id'];
      if (linkedId && !echteVariantIds.includes(linkedId)) {
        await cartChange(item.key, 0);
        changed = true;
      }
    }

    // 2) Pro Checkbox: hinzufügen oder Menge angleichen
    const checkboxes = document.querySelectorAll('.entsorgung-checkbox');

    for (const checkbox of checkboxes) {
      const material = checkbox.dataset.material;
      const produktVariantId = checkbox.dataset.variantId;
      const betragProStueck = parseFloat(checkbox.dataset.betrag);
      const key = storageKey(material, produktVariantId);

      const produkt = produktItems.find(i => String(i.variant_id) === String(produktVariantId));
      const produktMenge = produkt ? produkt.quantity : 1;
      const ziel = entsorgungZiel(checkbox, betragProStueck, produktMenge);
      const sollMenge = ziel.menge;

      const userHatDeaktiviert = sessionStorage.getItem(key) === 'true';

      const vorhanden = entsorgungItems.find(i =>
        i.properties['_entsorgung_material'] === material &&
        i.properties['_fuer_variant_id'] === produktVariantId
      );

      if (vorhanden) {
        checkbox.checked = true;
        sessionStorage.removeItem(key);
        if (String(vorhanden.variant_id) !== String(ziel.variantId)) {
          // alte Cent-Zeile (oder falsche Variante) gegen passende Variante tauschen
          await cartChange(vorhanden.key, 0);
          await cartAdd(ziel.variantId, sollMenge, entsorgungProps(material, produktVariantId));
          changed = true;
        } else if (vorhanden.quantity !== sollMenge) {
          await cartChange(vorhanden.key, sollMenge);
          changed = true;
        }
      } else if (userHatDeaktiviert) {
        checkbox.checked = false;
      } else {
        await cartAdd(ziel.variantId, sollMenge, entsorgungProps(material, produktVariantId));
        checkbox.checked = true;
        changed = true;
      }
    }

    if (changed) {
      await refreshCart();
      initCheckboxEvents();
      // Checkbox-Zustände nach dem Neu-Rendern setzen (Snippet rendert immer "checked")
      await applyCheckboxStates();
    }
  } catch(e) {
    console.error('Sync Fehler:', e);
  }
}

// Setzt nur die Häkchen passend zum Cart, ohne etwas zu ändern
async function applyCheckboxStates() {
  const cart = await getCart();
  const entsorgungItems = cart.items.filter(i =>
    i.properties && i.properties['_entsorgung_auto'] === 'true'
  );
  document.querySelectorAll('.entsorgung-checkbox').forEach(function(checkbox) {
    const material = checkbox.dataset.material;
    const produktVariantId = checkbox.dataset.variantId;
    checkbox.checked = entsorgungItems.some(i =>
      i.properties['_entsorgung_material'] === material &&
      i.properties['_fuer_variant_id'] === produktVariantId
    );
  });
}

function initCheckboxEvents() {
  document.querySelectorAll('.entsorgung-checkbox').forEach(function(checkbox) {
    checkbox.removeEventListener('change', onCheckboxChange);
    checkbox.addEventListener('change', onCheckboxChange);
  });
}

async function onCheckboxChange(event) {
  if (isProcessing) {
    event.target.checked = !event.target.checked;
    return;
  }
  isProcessing = true;

  const checkbox = event.target;
  const material = checkbox.dataset.material;
  const betragProStueck = parseFloat(checkbox.dataset.betrag);
  const variantId = ENTSORGUNGS_VARIANTEN[material];
  const produktVariantId = checkbox.dataset.variantId;
  const key = storageKey(material, produktVariantId);
  const label = checkbox.closest('label');

  if (label) label.style.opacity = '0.5';
  checkbox.disabled = true;

  try {
    await removeEntsorgung(variantId, produktVariantId, material);

    if (checkbox.checked) {
      sessionStorage.removeItem(key);
      const cart = await getCart();
      const produkt = cart.items.find(i =>
        String(i.variant_id) === String(produktVariantId) &&
        (!i.properties || i.properties['_entsorgung_auto'] !== 'true')
      );
      const produktMenge = produkt ? produkt.quantity : 1;
      const ziel = entsorgungZiel(checkbox, betragProStueck, produktMenge);
      await cartAdd(ziel.variantId, ziel.menge, entsorgungProps(material, produktVariantId));
    } else {
      sessionStorage.setItem(key, 'true');
    }

    await refreshCart();
    initCheckboxEvents();
    await applyCheckboxStates();
  } catch(e) {
    console.error('Fehler:', e);
    checkbox.checked = !checkbox.checked;
    checkbox.disabled = false;
    if (label) label.style.opacity = '1';
  } finally {
    isProcessing = false;
  }
}

async function removeEntsorgung(variantId, produktVariantId, material) {
  const cart = await getCart();
  const item = cart.items.find(i =>
    i.properties && i.properties['_entsorgung_auto'] === 'true' &&
    i.properties['_entsorgung_material'] === material &&
    i.properties['_fuer_variant_id'] === produktVariantId
  );
  if (!item) return;
  await cartChange(item.key, 0);
}

document.addEventListener('cart:updated', function() { scheduleSync(); });
document.addEventListener('shopify:section:load', function() { scheduleSync(); });